<template>
    <div class="lightbox v-application theme--light">
      <div
        class="outer"
        @click="overlay = !overlay"
      >
        <img
          :src="thumb || src"
        />
        <v-icon class="clickme print-never">search</v-icon>
      </div>
      <v-overlay v-if="overlay" :value="overlay">
        <v-btn
          class="closeBtn"
          fab
          color="secondary"
          @click="overlay = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-img
          :src="src"
          @click="overlay = false"
          max-height="95vh"
          max-width="95vw"
          min-height="4rem"
          min-width="4rem"
          width="95vw"
          :contain="true"
        >
          <template v-slot:placeholder>
            <v-layout
              fill-height
              align-center
              justify-center
              ma-0
              class="grey lighten-5"
            >
              <v-progress-circular indeterminate color="grey"></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
      </v-overlay>
    </div>
</template>

<script>
export default {
  name: 'Lightbox',
  props: [
    'thumb',
    'src'
  ],
  data() {
    return {
      overlay: false
    };
  },
}
</script>

<style lang="scss">

.lightbox {
  position: relative;

  @mixin img {
    width: unset;
    height: unset;
    max-width: 100%;
    object-fit: contain;
    display: block;
    margin: auto;
  }

  .outer {
    cursor: pointer;

    img {
      @include img;
    }
  }

  .closeBtn {
    position: absolute;
    top: -1.5rem;
    right: -1.5rem;
    z-index: 10;
  }

  .v-overlay .v-overlay__content {
    .v-image {
      cursor: pointer;
    }
  }

  .clickme {
    position: absolute;
    bottom: 0.25rem;
    right: 0.25rem;
    background: #fff;
    user-select: none;
    border-radius: 100%;
    padding: 0.25rem;
    opacity: 0.8;
  }

  .outer:hover .clickme {
    opacity: 1.0;
  }
}
</style>
